module.exports = __webpack_public_path__ + "img/dial.7d6fe645.png";